import { z } from 'zod';

export const CancelRecruitmentCampaignServiceRequestSchema = z
  .object({
    participationId: z.number().int(),
  })
  .describe('CancelRecruitmentCampaignServiceRequest');

export type CancelRecruitmentCampaignServiceRequest = z.infer<
  typeof CancelRecruitmentCampaignServiceRequestSchema
>;

// 204 No Content — 반환값 없음.
export const CancelRecruitmentCampaignServiceResponseSchema = z
  .void()
  .describe('CancelRecruitmentCampaignServiceResponse');

export type CancelRecruitmentCampaignServiceResponse = z.infer<
  typeof CancelRecruitmentCampaignServiceResponseSchema
>;
